import { useCallback, useState, useEffect } from 'react';
import { GetApplicationListQueryVariables, useGetApplicationListQuery } from 'views/utils/graphql/graphql';

export const useGetOrderStatus = (initVariables: GetApplicationListQueryVariables) => {
  const [symbolName, setSymbolName] = useState<string>(initVariables.symbolName || '');
  const [currentPage, setCurrentPage] = useState<number>(initVariables.page);

  const [orderStatusVariables, setOrderStatusVariables] = useState<GetApplicationListQueryVariables>(initVariables);
  const [getOrderStatusState, getOrderStatus] = useGetApplicationListQuery({
    variables: orderStatusVariables,
    requestPolicy: 'network-only',
  });

  // 銘柄名のセットと同時に検索する
  // setSymbolNameは一時的に保存する場合で検索は同時に行わない
  const setSymbolNameWithFetch = useCallback(
    (newSymbolName: string) => {
      setSymbolName(newSymbolName);
      //銘柄名を変更する場合は必ず1ページ目に戻る
      setCurrentPage(1);
      setOrderStatusVariables((state) => ({
        ...state,
        symbolName: newSymbolName,
        page: 1,
      }));
    },
    [setSymbolName, setCurrentPage],
  );

  // ページ変更の場合は即時に検索する
  useEffect(() => {
    setOrderStatusVariables((state) => ({
      ...state,
      page: currentPage,
    }));
  }, [currentPage]);

  return {
    symbolName,
    setSymbolName,
    currentPage,
    setCurrentPage,
    setSymbolNameWithFetch,
    getOrderStatusState,
  };
};
